import { render, staticRenderFns } from "./dados-adicionais.vue?vue&type=template&id=3553dc21"
import script from "./dados-adicionais.vue?vue&type=script&lang=js"
export * from "./dados-adicionais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports